import { AtsConnectPersistence } from './ats-connect.persistence';
import type {
  SearchSyncedApplications,
  SearchSyncedApplicationsOutput,
} from './ats-sync-application.type';
import { ErrorService } from '@/core/shared/errors/error.service';
import MeService from '@/core/shared/me/me.service';
import type { SyncedJobOutput } from './synced-job.type';

export default class AtsConnectService {
  private persistence = new AtsConnectPersistence();
  private meService = new MeService();

  public async syncJobApplicant(proUserProfileId: number, jobId: number): Promise<void> {
    await this.persistence.syncJobApplicant(proUserProfileId, jobId);
  }

  public async searchSyncedJobApplicants(
    params: SearchSyncedApplications,
  ): Promise<SearchSyncedApplicationsOutput> {
    const result = await this.persistence.searchSyncedJobApplicants({
      employerId: this.meService.employer?.id as number,
      search: params,
    });

    return result;
  }

  public async getSyncedJobByProjectId(projectId: number): Promise<SyncedJobOutput | null> {
    return this.persistence.getSyncedJobByProjectId(projectId);
  }

  public async hasActiveIntegration(): Promise<boolean> {
    const employerId = this.meService.employer?.id;

    if (!employerId) {
      ErrorService.captureMessage('Employer ID is not set, unable to check for active integration');
      return false;
    }

    const hasActiveIntegration = await this.persistence.hasActiveIntegrationForEmployer(employerId);
    return hasActiveIntegration;
  }
}
